import { ReactComponent as CartIcon } from "@/components/common/icons/cart.svg";
import { Cart } from "@/types/cart";
import { sendTreatmentCartClickedCartNav } from "@/utils/analytics/customEventTracking";
import { cn } from "@/utils/cn";

const ShoppingCartNavIcon = ({
  cart,
  openCart,
  className = "",
  baseCartAnalyticsArgs,
}: {
  cart?: Cart;
  openCart: () => void;
  className?: string;
  baseCartAnalyticsArgs: any;
}) => {
  const hasItemsInCart = cart && cart.line_items.length > 0;
  return (
    <div className={cn("relative flex", className)}>
      <CartIcon
        className="cursor-pointer h-6 w-6"
        onClick={() => {
          sendTreatmentCartClickedCartNav(baseCartAnalyticsArgs);
          openCart();
        }}
      />
      <div
        className={cn(
          "absolute top-1 -right-0.5 inline-block w-2 h-2 bg-dv-orange rounded-full",
          { hidden: !hasItemsInCart }
        )}
      />
    </div>
  );
};

export default ShoppingCartNavIcon;
